import React from "react";
import styled from "styled-components";

const EmptyResult = (props) => {
  const { icon, text } = props;

  return (
    // <div className="nothing-box">
    <Container className="nothing-box">
      <div>
        <img src={icon} alt="" />
        <p>{text}</p>
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export default EmptyResult;
